import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export function exportToExcel(filename, rows, columns) {
  const data = rows.map(r => {
    const o = {};
    columns.forEach(c => {
      const fmt = c.exportFmt || c.fmt;
      o[c.label] = fmt ? fmt(r[c.key], r) : (r[c.key] ?? "");
    });
    return o;
  });
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, `${filename}_${new Date().toISOString().slice(0, 10)}.xlsx`);
}

export function exportToPDF(title, rows, columns) {
  const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
  doc.setFillColor(30, 58, 138);
  doc.rect(0, 0, doc.internal.pageSize.getWidth(), 60, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("India Atul Motors", 40, 32);
  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");
  doc.text(title, 40, 50);
  doc.setTextColor(15, 23, 42);
  doc.setFontSize(9);
  doc.text(new Date().toLocaleString("en-IN"), doc.internal.pageSize.getWidth() - 40, 32, { align: "right" });

  autoTable(doc, {
    startY: 80,
    head: [columns.map(c => c.label)],
    body: rows.map(r => columns.map(c => {
      const fmt = c.exportFmt || c.fmt;
      return fmt ? fmt(r[c.key], r) : (r[c.key] ?? "");
    })),
    headStyles: { fillColor: [30, 58, 138], textColor: 255, fontSize: 9 },
    styles: { fontSize: 8, cellPadding: 4 },
    alternateRowStyles: { fillColor: [248, 250, 252] },
  });

  doc.save(`${title.replace(/\s+/g, "_")}_${new Date().toISOString().slice(0, 10)}.pdf`);
}
